import axios from 'axios'
import Cookies from 'js-cookie'
import { API_FEEDBACKS_HOST } from 'shared/config'
import { showToast } from 'shared/ui/toast/showToast'
import { keysToCamelCase } from './keysToCamelCase'
import { keysToSnakeCase } from './keysToSnakeCase'
import { serialize } from './paramsSerializer'

export const feedbacksInstance = axios.create({
  baseURL: `${API_FEEDBACKS_HOST}/api`,
  headers: {
    Authentication: import.meta.env.PROD
      ? Cookies.get('token')
      : localStorage.getItem('token'),
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },

  transformRequest: (data) => JSON.stringify(keysToSnakeCase(data)),
  paramsSerializer: { serialize },

  transformResponse: function (rawResponse, _, statusCode) {
    if (!rawResponse) return null

    if (statusCode && statusCode > 199 && statusCode < 400) {
      if (!rawResponse) return null

      const response = JSON.parse(rawResponse)

      return keysToCamelCase(response.data || response)
    }

    const requestUrl = this?.url
    //TODO:A temporary solution added due to the fact that the meeting_reviews endpoint throws a 404 if information on the previous 1-2-1 is not found. This is currently part of the functionality; after this misunderstanding is corrected, remove this from here.

    if (requestUrl?.includes('meeting_reviews')) return

    const data = JSON.parse(rawResponse)

    if (data.error) {
      showToast('error', data.error)
    } else if (Array.isArray(data.errors)) {
      const errorsMessage = data.errors
        .map((error: any) => error.title)
        .join(', ')

      showToast('error', errorsMessage)
    } else {
      showToast('error', '')
    }
  },
})
